module.exports = __webpack_public_path__ + "img/cog-regular.5cc98c5a.svg";